import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

/**
 * Fetch paginated playable feedback entries (admin).
 * config.params supports: keyword, podcastId, episodeId, page, limit
 */
function useGetPlayableFeedback(data = {}) {
  const { enabled = false, config = {}, queryKey } = data;
  const { params = {} } = config;
  const { privateFetch } = useContext(FetchContext);

  const key = queryKey ?? ['admin-playable-feedback', params];

  return useQuery(
    key,
    () => privateFetch.get('/v1/admin/podcast/playable-feedback', { params }).then((r) => r.data),
    { enabled, keepPreviousData: true }
  );
}

export default useGetPlayableFeedback;
